import { render, staticRenderFns } from "./BrandToggleButtonSize.vue?vue&type=template&id=ed4502d0&"
import script from "./BrandToggleButtonSize.vue?vue&type=script&lang=ts&"
export * from "./BrandToggleButtonSize.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports